<template>
  <span
    tabindex="0"
    class="pdf-preview-trigger"
    @click="showModal"
    @keypress.enter="showModal"
  >
    <slot />
  </span>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useModal } from 'vue-final-modal'
import PreviewModal from '@organisms/preview-modal/preview-modal.vue'
import emitter from '../../../emitter'

export default {
  name: 'pdf-preview-trigger',
  props: {
    url: {
      type: String,
      required: true
    },
    shareUrl: {
      type: String,
      required: false,
      default: ''
    },
    withoutShare: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const defaultSlot = ref(null)

    onMounted(() => {
      if (defaultSlot.value && defaultSlot.value[0]) {
        defaultSlot.value[0].setAttribute('tabindex', -1)
      }
      emitter.$on('closemodal', closeModal)
    })

    const modalInstance = useModal({
      component: PreviewModal,
      attrs: {
        clickToClose: true,
        escToClose: true,
        url: props.url,
        shareUrl: props.shareUrl,
        withoutShare: props.withoutShare,
        type: 'pdf'
      },
    })

    const showModal = (e) => {
      e.preventDefault()
      if (isOnMobile()) {
        if (props.shareUrl.length) {
          window.open(decodeURIComponent(props.shareUrl), '_blank')
        } else {
          window.open(props.url, '_blank')
        }
      } else {
        modalInstance.open()
      }
      const downloadList = e.target.closest('.download-list')
      const section = downloadList ? downloadList.querySelector('.downloadlist-section') : null

      window.dataLayer.push({
        event: 'file_download',
        section: section ? section.value : 'Download Info Container',
        label: e.target.innerText,
        file_extension: 'pdf',
        link_url: props.url,
      })
    }

    const closeModal = () => {
      modalInstance.close()
    }

    const isOnMobile = () => {
      return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i))
    }

    return {
      defaultSlot,
      showModal,
      closeModal
    }
  },
  data() {
    return {
      displayPreview: false,
      pdfPreviewUrl: null
    }
  },
}
</script>

<style lang="scss" scoped>
.pdf-preview-trigger {
  &:hover {
    cursor: pointer;
  }
}

.contrast-mode {
  .pdf-preview-trigger {

    &:hover,
    &:focus {
      button {
        border-color: red !important;
      }
    }
  }
}
</style>
